import { ActionButton } from '../ActionButton/ActionButton';
export var CommandButton = ActionButton;
//# sourceMappingURL=CommandButton.js.map